import { useSelector } from 'react-redux';

const useCreatePin = () => {
  const success = useSelector((state) => state.pin.createPinSuccess || {});
  const error = useSelector((state) => state.pin.createPinError || null);
  const isLoading = useSelector((state) => state.pin.createPinLoading);

  return { success, error, isLoading };
};

export default useCreatePin;
